import { useEffect, useState } from 'react';

/**
 * Порог мобильной раскладки страницы market.
 * ВАЖНО: должен совпадать с `@media (max-width: 1027px)` в CSS
 * (Main.css, ScheduleWrapper.css, ExchangeRate.css, Orders.css, OrderList.css, BuyOrder.css, Market.css).
 * 1028px — это же граница, с которой в проекте включается десктопный хедер.
 */
export const MOBILE_MAX_WIDTH = 1027;
const QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(QUERY).matches
        : false;

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(getMatch);

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return undefined;
        const mql = window.matchMedia(QUERY);
        const onChange = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else mql.addListener(onChange); // старые Safari
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange);
            else mql.removeListener(onChange);
        };
    }, []);

    return isMobile;
};

export default useIsMobile;
